import * as angular from "angular";

angular
  .module('bringoz.admin.itineraries')
  .constant('Itineraries_PN', {
    database: 'itineraries',
    isBranchEntity: false
  });
